<template>
	<v-sheet elevation="0">
		<RequirementConfirm
			ref="confirm"
			:confirmPackage="confirmPackage"
			@finishedCreateNew="finishedCreateNew"
		></RequirementConfirm>
		<!-- <FunctionTitle :title="mainTitle" /> -->
		<CommonFlame :title="pageTitle" class="mt-2">
			<!-- app-barに表示するボタン群 -->
			<template v-if="!$vuetify.breakpoint.xs" v-slot:app-bar-btn>
				<v-select
					v-model="pattern"
					:items="patternSubTitlesHash"
					class="on-app-bar-select"
					outlined
					dense
					hide-details
					clearable
					@change="getRequirementsByPattern()"
				/>
				<v-select
					v-model="selectedRequirementTypeId"
					:items="allRequirementTypes"
					class="on-app-bar-select"
					item-text="name"
					item-value="id"
					outlined
					dense
					hide-details
					clearable
					@change="getRequirementsByPattern()"
				/>
				<RequirementSearchDialog
					text
					ref="search"
					@setSearchedList="setSearchedList"
					:requirementTypes="typesForSearch"
					:statusIdsHash="statusIdsHash"
				/>
				<RequirementNewDialog
					ref="new"
					text
					:requirementTypes="requirementTypes"
					:user="user"
					@openConfirm="openConfirm"
				/>
				<v-btn :text="text" class="ml-2 white--text transparent" @click="reloadList">
					<v-icon class="mr-1">mdi-reload</v-icon>
					更新
				</v-btn>
			</template>
			<template v-if="$vuetify.breakpoint.xs">
				<v-row no-gutters class="mb-2" justify="end">
					<v-select
						v-model="pattern"
						:items="patternSubTitlesHash"
						class="on-app-bar-select"
						outlined
						dense
						hide-details
						clearable
						@change="getRequirementsByPattern()"
					/>
					<v-select
						v-model="selectedRequirementTypeId"
						:items="allRequirementTypes"
						class="on-app-bar-select"
						item-text="name"
						item-value="id"
						outlined
						dense
						hide-details
						clearable
						@change="getRequirementsByPattern()"
					/>
					<RequirementSearchDialog
						ref="search"
						@setSearchedList="setSearchedList"
						:requirementTypes="requirementTypes"
						:statusIdsHash="statusIdsHash"
					/>
					<RequirementNewDialog ref="new" :requirementTypes="requirementTypes" />
					<v-btn color="secondary" class="ml-2 pa-1 mx-2 my-1" @click="reloadList">
						<v-icon class="mr-1">mdi-reload</v-icon>
						更新
					</v-btn>
				</v-row>
				<v-divider />
			</template>

			<!-- 一覧画面部分 -->
			<div class="table-container px-2 mt-4">
				<v-data-table
					locale="ja-JP"
					:headers="headers"
					:items="requirements"
					:mobile-breakpoint="240"
					hide-default-footer
					disable-filtering
					disable-pagination
					no-data-text="データがありません。"
				>
					<template v-slot:item="{ item, index }">
						<tr @click="showDialog(item.id, index)">
							<td class="py-1">{{ item.status_id_i18n }}</td>
							<td class="py-1">
								{{ item.requirement_type.name }} <br />
								{{ item.subtitle }}
							</td>
							<td class="py-1">
								{{
									$store.getters.department(item.from_department_id) != null
										? $store.getters.department(item.from_department_id).name
										: ""
								}}
							</td>
							<td class="py-1">{{ item.user.full_name }}</td>
							<td class="py-1">
								{{
									$store.getters.department(item.to_department_id) != null
										? $store.getters.department(item.to_department_id).name
										: ""
								}}
							</td>
							<td class="no-wrap py-1">
								{{ item.responder != null ? item.responder.full_name : "" }}
							</td>
							<td class="no-wrap py-1">
								{{ item.requirement_date ? common.formatDate(item.requirement_date) : "" }}
							</td>
							<td :class="diffDate(item.deadline) ? 'red-bold no-wrap py-1' : 'no-wrap py-1'">
								{{ common.formatDate(item.deadline) }}
								<v-icon v-if="checkUpdate(item, 'deadline')">mdi-clock-edit-outline</v-icon>
							</td>
							<td class="no-wrap py-1">
								<div v-if="item.requirement_type.need_matter_flag" class="d-flex">
									<p>{{ common.returnMatterInfo(item.matter) }}</p>
									<v-icon v-if="checkUpdate(item, 'matter_id')">mdi-clock-edit-outline</v-icon>
								</div>
							</td>
						</tr>
					</template>
				</v-data-table>
			</div>
			<PaginationModule :pagination="pagination" @get-page="getPage($event)" />
		</CommonFlame>
		<RequirementShowDialog
			ref="show"
			@reloadIndex="reloadList"
			@update-requirement="updateRequirement($event)"
		/>
	</v-sheet>
</template>
<script>
import moment from "moment"
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import common from "../../helper/common"
import FunctionTitle from "../shared/FunctionTitle.vue"
import CommonFlame from "../shared/CommonFlame.vue"
import PaginationModule from "../shared/PaginationModule.vue"
import RequirementNewDialog from "./components/RequirementNewDialog.vue"
import RequirementShowDialog from "./components/RequirementInfoDialog.vue"
// import RequirementShowDialog from "./components/RequirementShowDialog.vue"
import RequirementSearchDialog from "./components/RequirementSearchDialog.vue"
import RequirementConfirm from "./components/RequirementConfirm.vue"

export default {
	props: {
		id: {
			type: Number,
			required: false,
		},
	},
	components: {
		FunctionTitle,
		CommonFlame,
		RequirementShowDialog,
		RequirementSearchDialog,
		RequirementNewDialog,
		PaginationModule,
		RequirementConfirm,
	},
	filters: {
		toMoment(date) {
			return moment(date).format("YYYY/MM/DD")
		},
	},
	data() {
		return {
			patternSubTitlesHash: [
				{ text: "この部門への依頼", value: "to_my_department" },
				{ text: "この部門からの依頼", value: "from_my_department" },
				{ text: "自身が作成した依頼", value: "my_requirements" },
				{ text: "自身が担当している依頼", value: "my_tasks" },
			],
			user: {},
			text: "",
			confirmPackage: {},
			pattern: "to_my_department",
			mainTitle: "",
			pageTitle: "依頼機能 | 依頼一覧",
			userDepartmentFlag: false,
			requirements: [],
			statusIdsHash: {},
			requirementTypes: [],
			typesForSearch: [],
			allRequirementTypes: [],
			headers: [
				{
					text: "状態",
					align: "start",
					value: "status_id",
					width: "100px",
				},
				{ width: "200px", text: "依頼の種類", value: "requirement_type_name" },
				{ width: "150px", text: "依頼元部門", value: "from_department_name" },
				{ width: "150px", text: "依頼者", value: "user_name" },
				{ width: "150px", text: "依頼先部門", value: "to_department_name" },
				{ width: "150px", text: "担当者", value: "responder_name" },
				{ width: "150px", text: "依頼発行日", value: "requirement_date" },
				{ width: "150px", text: "希望納期", value: "deadline" },
				{ width: "250px", text: "案件", value: "matter" },
			],
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
			selectedRequirementTypeId: null,
			searchedFlag: false,
			common,
		}
	},
	mounted() {
		const page = this.$route.query.page ? this.$route.query.page : 1
		this.getRequirementsByPattern(page)
		if (this.id) {
			console.log(this.id)
			this.showDialog(this.id, 1)
		}
	},
	watch: {},
	methods: {
		getPage(page) {
			this.reloadListWithPage(page)
		},
		updateValues(values) {
			this.$refs.show.updateValues(values)
		},
		tranceMoment(data) {
			return moment(data).format("YYYY/MM/DD")
		},

		diffDate(deadline) {
			let today = moment(new Date())
			let gap = moment(deadline).diff(today, "days")
			if (gap <= 5) {
				return true
			} else {
				false
			}
		},
		updateValue(dataSet) {
			this.$refs.editValue.setEditData(dataSet)
		},
		returnMatterInfo(matter) {
			return common.returnMatterInfo(matter)
		},
		sortCreatedAt(objectArry) {
			let sorted = objectArry.slice().sort(function (a, b) {
				return a.created_at < b.created_at ? -1 : 1
			})
			return sorted
		},
		checkUpdate(data, key) {
			let keyValues = data.requirement_fixes.filter((fix) => fix[key] != null)
			if (keyValues.length > 0) {
				return true
			} else {
				return false
			}
		},
		returnFixValue(data, key) {
			let keyValuesSorted = this.sortCreatedAt(data.requirement_fixes).filter((fix) => {
				if (fix[key] != null) {
					return fix
				}
			})
			if (keyValuesSorted.length > 0) {
				let value = ""
				keyValuesSorted.forEach((fix) => {
					value = fix[key]
				})
				console.log(value)
				return value
			} else {
				return data[key]
			}
		},
		reloadList() {
			if (!this.searchedFlag) {
				this.getRequirementsByPattern(this.$route.query.page ? this.$route.query.page : 1)
			} else {
				this.$refs.search.getResult(this.$route.query.page ? this.$route.query.page : 1)
			}
		},
		reloadListWithPage(page) {
			if (!this.searchedFlag) {
				this.getRequirementsByPattern(page)
			} else {
				this.$refs.search.getResult(page)
			}
		},
		setSearchedList(requirements, pagination) {
			this.pagination = pagination
			this.searchedFlag = true
			this.requirements = requirements
		},
		tranceJa(word) {
			return this.statusIdsHash[word]
		},
		showDialog(id, index) {
			this.$refs.show.openDialog(id, index)
		},
		getRequirementsByPattern(page) {
			this.searchedFlag = false
			const headers = authenticate.setHeader()
			axios
				.get(
					"/erp/v1/departments/" + this.$store.getters.selectedDepartment.id + "/requirements.json",
					{
						headers,
						params: {
							pattern: this.pattern,
							page: page,
							responder_present: true,
							selctedRequirementTypeId: this.selectedRequirementTypeId,
						},
					}
				)
				.then((response) => {
					this.requirements = response.data.requirements
					this.statusIdsHash = response.data.status_ids_hash
					this.requirementTypes = response.data.requirement_types
					this.user = response.data.user
					this.typesForSearch = response.data.department_requirement_types
					this.pagination = response.data.pagination
					this.allRequirementTypes = response.data.all_requirement_types
				})
				.catch((err) => {
					console.log(err)
					errorHandling.errorResponse(err)
				})
		},
		openConfirm(dataSet) {
			this.confirmPackage = dataSet
			this.$refs.confirm.openDialog()
		},
		finishedCreateNew() {
			this.$refs.new.closeDialog()
			this.reloadList()
		},
		updateRequirement(requirement) {
			const oldRequirement = this.requirements.find((r) => r.id == requirement.id)
			const index = this.requirements.indexOf(oldRequirement)
			this.$set(this.requirements, index, requirement)
		},
	},
	computed: {},
}
</script>
<style lang="scss" scoped>
.on-app-bar-select {
	background: white;
	width: 0;
	max-width: 225px;
	width: 100%;
	min-width: 150px;
}
.no-wrap {
	white-space: nowrap !important;
}
.pre-wrap {
	white-space: pre-wrap !important;
}
.pre-line {
	white-space: pre-wrap !important;
}
.red-bold {
	color: red;
	font-weight: bold;
}
td div p {
	white-space: pre-wrap;
}
</style>
